import { forKey } from '../../type-transformer/type-transformer.use-case';

export class FeatureFlags {
  @forKey('example_flag')
  exampleFlag = false; //Leave for testing
  @forKey('EMPTY_FLAG')
  emptyFlag = false;
  @forKey('DISABLE_RESTART')
  disableRestartDialog = false;
  @forKey('ENABLE_VERBOSE_CLIENT_LOGGING')
  enableVerboseLogging = false;
  @forKey('ENABLE_SHORT_LOCATION_SAMPLING')
  enableShortLocationSampling = false;
  @forKey('ENABLE_UPTIME_PING')
  enableUptimePing = false;
}
